export default {
  'developer_eccang_open': {
    cn: '易仓科技开放平台',
    en: 'Eccang Open Platform',
    kr: ''
  },
  'developer_title_desc': {
    cn: '自有应用取消授权可在开放平台作废该应用',
    en: ' SelfOwned application deLicensing can invalidate an application on an open platform'
  },
  'developer_my_application': { cn: '我的应用', en: 'My application' },
  'developer_third_applications': { cn: '第三方应用', en: 'ThirdParty applications' },
  'developer_list_default_auth_text': { cn: '列表默认显示当前账号创建的应用，支持对【第三方应用】进行授权，【第三方应用】授权请点击{a}来操作', en: 'By default, the list shows the application created by the current account, which supports the authorization of【third-party application】. Please click {a} to operate 【third-party application】' },
  'developer_you_can1': {
    cn: '你还没有创建应用，您可以',
    en: "You haven't created the app yet, you can"
  },
  'developer_you_can2': {
    cn: '1. 到{platform}中创建您的应用，自有应用创建成功后自动获取授权',
    en: '1. Create your application on the {platform}, and automatically obtain authorization after the successful creation of your own application'
  },
  'developer_you_can3': {
    cn: '2. 点击{add}可以为【第三方应用】开通授权',
    en: '2. Click {add} to open authorization for the 【third-party application】'
  },
  'developer_proprietary_app_get': { cn: '自有应用默认获取授权', en: 'Self-owned applications are authorized by default' },
  'developer_add_app_before_add_comp': { cn: '应用授权前请先添加企业信息', en: 'Add enterprise information before applying authorization' },

  // 新增授权-modal
  'developer_be_auth_to_cancel_pp': {
    cn: '该应用已授权，取消授权请在授权列表页面操作',
    en: 'The application has been authorized. Please cancel the authorization in list page with authorization'
  },
  'developer_authorizing_application_by': {
    cn: '您正在为{0}应用开通授权',
    en: 'You are opening authorization for {0} app'
  },
  'developer_select_auth_text': {
    cn: '请选择授权的接口，默认显示该应用已申请的全部接口，若未显示，则该应用没有该申请接口，若接口置灰不可点则代表您没有这个接口权限，无法进行授权',
    en: 'Select the authorized interface. All the interfaces that have been applied for will be displayed by default. If not, the application does not have the interface. If the interface is grayed out, it means that you do not have the permission and cannot be authorized'
  },
  'developer_app_not_req_interface': { cn: '该应用未申请该系统接口', en: 'The application does not apply for an system interface' },

  // 编辑授权-modal
  'developer_editing_auth_t': { cn: '您正在编辑{app}应用的授权', en: 'You are editing the authorization of the {app}' },
  'developer_edit_default_auth_permission_text': {
    cn: '默认显示该应用已申请且您有权限进行授权的接口，若未显示，则该应用没有申请该接口或您没有该接口的权限勾选后提交可对该接口进行授权<br>不勾选或取消候选则默认不对该接口进行授权',
    en: 'The interface that the application has applied for and you have the permission to authorize is displayed by default. If not, the application does not apply for the interface or you do not have the permission. Check and submit to authorize the interface < br > if you do not check or cancel the candidate, the interface is not be authorized by default'
  },
  'developer_concat_user_center': {
    cn: '您可以联系易仓科技商户在用户中心为您授权',
    en: 'You can contact ECCANG merchant to authorize for you in the user center'
  },
  // 查看接口授权情况
  'developer_look_interface_auth': { cn: '查看接口授权情况', en: 'Look at interface authorization' },
  // 'developer_': { cn: '授权', en: '' },
  // 'developer_': { cn: '授权', en: '' },
  // 'developer_': { cn: '授权', en: '' },
  // 'developer_': { cn: '授权', en: '' },
  // 'developer_': { cn: '授权', en: '' },
  // table + form
  'developer_app_name': { cn: '应用名称', en: 'Application name' },
  'developer_app_type': { cn: '应用类型', en: 'Application type' },
  'developer_authorization_interface': { cn: '授权接口', en: 'Authorization interface' },
  'developer_authorization_status': { cn: '授权状态', en: 'Authorization status' },
  'developer_authorization_time': { cn: '授权时间', en: 'Authorization time' },
  'developer_operation': { cn: '操作', en: 'Operation' },
  'developer_operator': { cn: '操作人', en: 'Operator' },
  'developer_operation_type': { cn: '操作类型', en: 'Operation type' },
  'developer_operation_content': { cn: '操作内容', en: 'Content' },
  'developer_service_interface': { cn: '服务接口', en: 'Service interface' }
}
